module.exports = __webpack_public_path__ + "img/img0108.f82e550d.png";